import { ShoppingCart, Plus, Minus, Trash, SpinnerGap } from '@phosphor-icons/react';
import { fmt } from './styles';

function CartRow({ item, onUpdateQty, onRemove }) {
  const price = Number(item.PrecoUnitario ?? item.PrecoBaseConsultor) || 0;
  const qty = Number(item.Quantidade);
  return (
    <tr data-testid={`cart-item-${item.ID_Carrinho}`} className="hover:bg-[#F9FAFB]">
      <td className="px-3 py-2 text-[#111827] font-medium">{item.Descricao}</td>
      <td className="px-3 py-2 text-right text-[#6B7280]">{fmt(price)}</td>
      <td className="px-3 py-2">
        <div className="flex items-center justify-center gap-1">
          <button onClick={() => onUpdateQty(item.ID_Carrinho, qty - 1)} disabled={qty <= 1}
            className="p-1 rounded hover:bg-[#F3F4F6] disabled:opacity-30 text-[#6B7280]"><Minus size={14} /></button>
          <span className="w-8 text-center text-sm font-semibold">{qty}</span>
          <button onClick={() => onUpdateQty(item.ID_Carrinho, qty + 1)}
            className="p-1 rounded hover:bg-[#F3F4F6] text-[#6B7280]"><Plus size={14} /></button>
        </div>
      </td>
      <td className="px-3 py-2 text-right font-semibold text-[#0F1829]">{fmt(price * qty)}</td>
      <td className="px-3 py-2 text-center">
        <button onClick={() => onRemove(item.ID_Carrinho)}
          className="p-1 rounded hover:bg-red-50 text-[#9CA3AF] hover:text-red-500 transition-colors"><Trash size={16} /></button>
      </td>
    </tr>
  );
}

export default function CartSection({ cart, loading, total, netPoints, onUpdateQty, onRemove, onClear }) {
  return (
    <div className="bg-white rounded-xl border border-[#E5E7EB] shadow-sm mb-6" data-testid="section-cart">
      <div className="px-5 py-3 border-b border-[#E5E7EB] bg-[#F9FAFB] rounded-t-xl flex items-center justify-between">
        <div className="flex items-center gap-2">
          <ShoppingCart size={18} className="text-[#0F1829]" />
          <h2 className="text-sm font-semibold text-[#111827]">Carrinho</h2>
        </div>
        {cart.length > 0 && (
          <button onClick={onClear} data-testid="clear-cart-btn"
            className="p-1.5 rounded hover:bg-red-50 text-[#9CA3AF] hover:text-red-500 transition-colors"
            title="Limpar"><Trash size={18} /></button>
        )}
      </div>
      <div className="p-5">
        {loading ? (
          <div className="flex justify-center py-6">
            <SpinnerGap size={24} className="animate-spin text-[#0F1829]" />
          </div>
        ) : cart.length === 0 ? (
          <p className="text-sm text-[#9CA3AF] text-center py-6">Carrinho vazio.</p>
        ) : (
          <>
            <div className="border border-[#E5E7EB] rounded-lg overflow-hidden mb-4">
              <div className="overflow-x-auto">
              <table className="w-full text-sm" data-testid="cart-table">
                <thead>
                  <tr className="bg-[#F9FAFB] text-[#6B7280] text-xs uppercase tracking-wide">
                    <th className="px-3 py-2 text-left font-medium">Produto</th>
                    <th className="px-3 py-2 text-right font-medium w-24">Preço</th>
                    <th className="px-3 py-2 text-center font-medium w-32">Qtd</th>
                    <th className="px-3 py-2 text-right font-medium w-24">Total</th>
                    <th className="px-3 py-2 w-12"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#E5E7EB]">
                  {cart.map((c) => (
                    <CartRow key={c.ID_Carrinho} item={c}
                      onUpdateQty={onUpdateQty} onRemove={onRemove} />
                  ))}
                </tbody>
              </table>
              </div>
            </div>
            <div className="flex flex-col items-center gap-1">
              <span className="text-lg font-bold text-[#111827]">Total: {fmt(total)}</span>
              {netPoints > 0 && (
                <span className="text-sm text-green-600">
                  NetPoints da Encomenda: {netPoints.toFixed(2)}
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
